import { type WritableDraft } from 'immer';
import { type Observable, of } from 'rxjs';

import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type EngineState } from '../../../+state/engine';
import {
  AbstractAiElementHandler,
  applyFieldSize,
  getElement,
  getInitialProps,
  patchFieldLabel,
  upsertElement,
} from '../../../ai';

import { type TextFieldContext } from './text-field.definition';

export class TextFieldElementHandler extends AbstractAiElementHandler<'textField'> {
  readonly type = 'textField';

  prepare(context: TextFieldContext): Observable<TextFieldContext> {
    this.resolveElementIcon(context.element);

    return of(context);
  }

  process(context: TextFieldContext, draft: WritableDraft<EngineState>): void {
    let props: PartialPropsOf<'textField'> = getInitialProps<'textField'>(
      draft,
      context.element.id,
      {},
    );
    props = patchFieldLabel<'textField'>(props, context.element);

    if (context.element.placeholder !== undefined) {
      props = applyPropsPatch<'textField'>(props, {
        content: { input: { placeholder: context.element.placeholder } },
      });
    }

    const { elementId } = upsertElement(draft, context, props);
    applyFieldSize<'textField'>(getElement(draft, elementId, 'textField'), context.element);
  }
}
